export default { getItem, setItem };

export function getItem(
  key: string,
  done: (err: any, value: any) => void
): void {
  let value = window.localStorage[key];
  if (value) {
    try {
      value = JSON.parse(value);
    } catch (e) {
      /* ignore */
    }
  }
  done(null, value);
}
type SetParams = { key: string; value?: any };
export function setItem(params: SetParams, done?: (err: any) => void): void {
  window.localStorage[params.key] = JSON.stringify(params.value);
  done?.(null);
}
